/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type TherapyMedicationDtoPhase = (typeof TherapyMedicationDtoPhase)[keyof typeof TherapyMedicationDtoPhase];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TherapyMedicationDtoPhase = {
  PHASE_1: 'PHASE_1',
  PHASE_2: 'PHASE_2',
} as const;
